// extracted by mini-css-extract-plugin
module.exports = {"footer":"_1SufrW","zoom":"_9dR_l7","btn":"inp7b4","share":"ltgNfW","newsButton":"FQ4SuA"};